import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function LHManaging() {
  return <section className="bg-black py-[60px] lg:py-[100px] overflow-hidden" data-id="element-1610">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-1611">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-20" data-id="element-1612">
          {/* Left Column - Image */}
          <AnimateOnScroll className="w-full lg:w-[45%]" delay={200} data-id="element-1613">
            <div className="relative w-full aspect-[3/4] overflow-hidden shadow-xl" data-id="element-1614">
              <img src="https://cdn.magicpatterns.com/uploads/mnFBgZHGDUS96RyYJEAN6s/hair-growth.jpg" alt="Smooth Skin Results" className="w-full h-full object-cover" data-id="element-1615" />
            </div>
          </AnimateOnScroll>

          {/* Right Column - Text */}
          <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-1616">
            <h2 className="text-[24px] lg:text-[36px] uppercase text-white leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-1617">
              HOW TO MANAGE HAIR GROWTH BETWEEN SESSIONS
            </h2>

            <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-1618"></div>

            <div className="space-y-6 text-[#B0B0B0] text-base leading-[1.8] font-body" data-id="element-1619">
              <p data-id="element-1620">
                We often get asked about managing hair growth between laser hair
                reduction sessions. The recommended approach is to shave the
                treated area. Shaving is a safe and effective method for
                controlling hair growth during laser hair removal treatments.
              </p>
              <p data-id="element-1621">
                Shaving is the preferred option over waxing or plucking during a
                laser hair removal regimen. Waxing and plucking can disrupt the
                hair follicles, which may affect the laser's ability to target
                them accurately. Shaving, however, enables the laser to reach
                the hair follicles without any disruption, resulting in more
                successful hair reduction.
              </p>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}